

import React from 'react';
import { Box, Card, Divider, TableBody } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Sample from "../../AdminDashboard/Onsite And Offsite/Sample.json";
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Paginator from "../../../toolkit/Paginator";
import RightArrowOpen from "../../../icons/RightArrowOpen.svg";
import Edit from "../../../icons/edit.svg";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import axios from '../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Nodata from "../../Nodata/Nodata";
import { ToastContainer, toast } from 'react-toastify';
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";


export default function Departments() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };


    const [open, setOpen] = useState(false);
    const [Tab, setTab] = useState("");
    const [spinner, setSpinner] = React.useState(false);
    const [ClientList, setClientList] = React.useState([]);
    const [clientId, setClientId] = React.useState("");
    const [DepartmentsList, setDepartmentsList] = React.useState([]);
    const [DepartmentCount, setDepartmentCount] = React.useState("");
    const [number, setNumber] = useState("1");
    const [Search, setSearch] = useState("");
    const [departmentName, setDepartmentName] = useState("");
    const [id, setId] = useState("");
    const [state, setSate] = useState(false);

    const handleClickOpen = (num, data) => {
        setSate(false)
        setTab(num);
        setOpen(true);
        setClientId(num == 2 ? data?.clientId : "");
        setDepartmentName(num == 2 ? data?.departmentName : "");
        setId(num == 2 ? data?.id : 0);

    };

    const handleClose = () => {
        setOpen(false);
        setSate(false);
    };
    const SpinnerClose = () => {
        setSpinner(false);
    };

    useEffect(() => {
        Details();
        GetDepartments();
    }, [number, Search]);

    async function Details() {
        const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false");
        setClientList(res?.data?.data);
    }
    const GetDepartments = async () => {
        setSpinner(!spinner);
        const resp = await axios.get("SystemUser/GetDepartments?pageSize=" + 12 + "&pageNumber=" + number + "&filters=" + Search);
        setDepartmentsList(resp?.data?.data);
        setDepartmentCount(resp?.data?.count);
        setSpinner(spinner);
    }

    const FreeSearch = (e) => {
        setSearch(e.target.value);
    }
    const handlePageChange = (event) => {
        setNumber(event);
    };
    const AddorEditDepartments = async () => {
        setSate(true);
        if (departmentName != "" && clientId != "") {
            const ClientName = ClientList?.find((r) => r?.value == clientId)?.text;
            const obj = {
                "id": id,
                "departmentName": departmentName,
                "clientName": ClientName,
                "clientId": clientId
            }
            axios.post("SystemUser/AddUpdateDepartment", obj)
                .then((res) => {
                    if (res?.data) {
                        handleClose();
                        toastNotify(res?.data?.responseMessage, true);
                        GetDepartments();
                    } else {
                        toastNotify(res?.data?.responseMessage, false);
                        setOpen(true);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    setSate(false);
                });
            // const res = await axios.post("SystemUser/AddUpdateDepartment", obj);
            // if (res?.data?.responseCode == 100) {
            //     toastNotify(res?.data?.responseMessage, true);
            //     GetDepartments();
            //     handleClose();
            // } else {
            //     toastNotify(res?.data?.responseMessage, false);
            //     setOpen(true);
            // }
        } else {
            toastNotify("Please enter mandatory fields", false);
            setOpen(true);
            setSate(false);
        }
    }
    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Card>
                <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
                    <DialogContent sx={{ padding: "48px 48px" }}>
                        <DialogTitle
                            sx={{
                                textAlign: "center",
                                fontWeight: 500,
                                fontSize: 20,
                            }}
                        >
                            <span style={{ fontSize: "larger" }} >{Tab == 1 ? " Add Department " : " Edit Department "}</span>
                        </DialogTitle>

                        <DialogActions >
                            <div>

                                <div>

                                    <div className='mt-2'>
                                        <span style={{ color: "#3E4A62" }}> Client <span style={{ color: "red" }}>*</span></span>
                                        <br />
                                        <Select
                                            sx={{
                                                '& legend': { display: 'none' },
                                                '& fieldset': { top: 0 },
                                                width: "320px",
                                            }}
                                            labelId="demo-multiple-name-label"
                                            id="demo-multiple-name"
                                            size="small"
                                            value={clientId || ""}
                                            onChange={(e) => setClientId(e.target.value)}
                                            MenuProps={MenuProps}
                                            disabled={Tab == 2}
                                        >
                                            {ClientList?.map((r, i) =>
                                                <MenuItem key={i} value={r?.value}>{r?.text}</MenuItem>
                                            )}
                                        </Select>

                                    </div>
                                    <div >
                                        <span style={{ color: "#3E4A62" }}>Department Name <span style={{ color: "red" }}>*</span></span>
                                        <br />
                                        <TextField
                                            placeholder='Department Name'
                                            sx={{
                                                "& legend": { display: "none" },
                                                "& fieldset": { top: 0 },
                                                fontFamily: "Arial, FontAwesome",
                                                width: "320px"
                                            }}
                                            variant="outlined"
                                            size="small"
                                            value={departmentName || ""}
                                            onChange={(e) => setDepartmentName(e?.target?.value)}
                                        />

                                    </div>
                                </div>

                                <DialogActions >
                                    <div className="login-help__buttonContainer mt-4">
                                        <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                                        <Button variant="contained" className="login-button-request mx-2" disabled={state == true} onClick={AddorEditDepartments}>{Tab == 1 ? "Add " : "Save"}</Button>
                                    </div>

                                </DialogActions>
                            </div >
                        </DialogActions>



                    </DialogContent>
                </Dialog>

                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <h3> Departments</h3>
                    </div>
                </div>

                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                    <Stack spacing={2} direction="row">
                        <TextField
                            placeholder='Search'
                            sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                fontFamily: "Arial, FontAwesome"
                            }}
                            variant="outlined"
                            size="small"
                            value={Search}
                            onChange={(e) => FreeSearch(e)}
                        />
                        {HasPermissions(INFO?.AddDepartments?.actionName, PER?.ScreenPermissions?.Insert) &&
                            <div style={{ marginLeft: "Auto", padding: "10px" }}>
                                <Button variant="contained" sx={{ padding: "inherit" }} onClick={() => handleClickOpen(1, "")}>+ Add New</Button>
                            </div>
                        }
                    </Stack >

                </div>
                <Box sx={{ backgroundColor: '#f8f9fa' }}>

                    < TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                        <Table aria-label="customized table">
                            {DepartmentCount < 1 ? <div hidden={spinner}><Nodata /> </div> : <>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Client Name</span>	</StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Department Name</span></StyledTableCell>
                                        <StyledTableCell >&nbsp;</StyledTableCell>
                                    </TableRow>
                                </TableHead>

                                {DepartmentsList?.map((r, i) =>
                                    <TableBody key={i}>
                                        <TableRow key={i}>
                                            <StyledTableCell sx={{ width: "30%" }}>
                                                {r?.clientName}
                                            </StyledTableCell>
                                            <StyledTableCell sx={{ width: "30%" }} >
                                                {r?.departmentName}
                                            </StyledTableCell>
                                            <StyledTableCell sx={{ width: "5%" }} >
                                                {HasPermissions(INFO?.AddDepartments?.actionName, PER?.ScreenPermissions?.Modify) &&
                                                    <IconButton aria-label="edit" onClick={() => handleClickOpen(2, r)}>
                                                        <img src={Edit} alt="editicon" />
                                                    </IconButton>
                                                }
                                            </StyledTableCell>
                                        </TableRow>
                                    </TableBody>
                                )}
                            </>}
                        </Table>

                    </TableContainer>

                </Box >


            </Card >
            <div hidden={DepartmentCount < 1}>
                <Paginator
                    count={Math.ceil(DepartmentCount / 12)}
                    page={Number(number)}
                    margin="18px 0px"
                    onChange={handlePageChange}
                />
            </div>
        </>
    )
}


